import React, { useContext, useEffect, useState} from 'react';
import UnstakePopup from "./unstake-popup.js";
import LockPopup from "./lock-popup.js";
import StakePopup from "./stake-popup.js";
import EcosystemStats from "./ecosystem-stats.js";
import LockTable from "./lock-table.js";
import AOS from "aos";
import "aos/dist/aos.css";
import Web3 from "web3";
import Context from "../../../context/context";
import Swal  from "sweetalert2";
import Staking from '../abi/staking.json';
import pTGC from '../abi/pTGC.json';
import { providerURL, formatDateAndtime, txAfterDone, txDone, txStart} from "../utils";
import { formatUnits } from "ethers";

const IndexWrapper = () => {

  const {account, onConnect, providers, ptgcPrice} = useContext(Context);

  const [withdrawModal, setWithdrawModal] = useState(false);
  const [lockModal, setLockModal] = useState(false);
  const [stakeModal, setStakeModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [minStaking, setMinStaking] = useState(0);
  const [pTGCBalance, setpTGCBalance] = useState(0);
  const [pTGCAllowance, setpTGCAllowance] = useState(0);
  const [lockReward, setLockReward] = useState(0);
  const [stakeReward, setStakeReward] = useState(0);
  const [lockedpTGC, setLockedpTGC] = useState(0);
  const [unlockedpTGC, setUnLockedpTGC] = useState(0);
  const [stakedpTGC, setStakedpTGC] = useState(0);
  const [unstakedpTGC, setUnstakedpTGC] = useState(0);
  const [lastStakingTime, setLastStakingTime] = useState('00:00:00')
  const [currentTime, setCurrentTime] = useState(0);
  const [lockHistory, setLockHistory] = useState([]);
  const [lockID, setLockID] = useState([]);
  const [earnedFromHolding, setEarnedFromHolding] = useState(0)
  const [PTGCEarned, setPTGCEarned] = useState(0)
  const [earnedFromStaking, setEarnedFromStaking] = useState(0)
  const [earnedFromLocking, setEarnedFromLocking] = useState(0)

  useEffect(() => {
    if(account) 
    {
      getData();
    }
  }, [account, refresh]);

  const getData = async () => {
    const web3 = new Web3(providers);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
    const pTGCContract = new web3.eth.Contract(pTGC.ABI, pTGC.Contract);

    setMinStaking(Number(formatUnits(await stakingContract.methods.minStakingToken().call(), 18)));
    setpTGCAllowance(Number(formatUnits(await pTGCContract.methods.allowance(account, pTGC.Contract).call(), 18)));

    let userInfo = await stakingContract.methods.mapUserInfo(account).call();
    try  {
      let pendingReward = Number(formatUnits(await stakingContract.methods.pendingReward(account).call(), 18));
      setStakeReward(pendingReward + Number(formatUnits(userInfo.pendingToClaimed, 18)));
    } catch (err)  {
      setStakeReward(Number(formatUnits(userInfo.pendingToClaimed, 18)));
    }

    if (userInfo[2] != 0)  {
      setLastStakingTime(formatDateAndtime(new Date(parseInt(userInfo[2]) * 1000)));
    }

    let totalReceived = Number(formatUnits(await pTGCContract.methods.totalReceived(account).call(), 18));
    let totalSend = Number(formatUnits(await pTGCContract.methods.totalSend(account).call(), 18));
    let totalBalance = Number(formatUnits(await pTGCContract.methods.balanceOf(account).call(), 18));

    let earnedFromStaking = Number(formatUnits(userInfo.claimed, 18));
    let earnedFromLocking = Number(formatUnits(userInfo.lockClaimed, 18));
    let earnedFromHolding = (totalReceived + totalBalance) > totalSend ? ((totalSend + totalBalance) - totalReceived) : parseInt(0);
    
    setEarnedFromHolding(earnedFromHolding);
    setEarnedFromStaking(earnedFromStaking);
    setEarnedFromLocking(earnedFromLocking);
    setPTGCEarned(earnedFromHolding + earnedFromStaking + earnedFromLocking);

    setpTGCBalance(totalBalance);
    setLockedpTGC(Number(formatUnits(userInfo.locked, 18)));
    setStakedpTGC(Number(formatUnits(userInfo.amount, 18)));
    setUnLockedpTGC(Number(formatUnits(userInfo.amount, 18)) - Number(formatUnits(userInfo.locked, 18)));
    setUnstakedpTGC(totalBalance - Number(formatUnits(userInfo.amount, 18)));

    if (userInfo.locked > 0) {
      await getLockedData();
    }
  }

  const getLockedData = async () => {
    const web3 = new Web3(providers);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);

    let pendingReward = 0;
    let lockedEntry = [];
    let lockCount = parseInt(await stakingContract.methods.lockCount(account).call());

    setCurrentTime(Math.floor(Date.now() / 1000));

    let lockedID = [];
    for (let i = 1; i <= lockCount; i++) {

      let lockInfo = await stakingContract.methods.mapUserInfoLock(account, i).call()
      let reward = Number(formatUnits(await stakingContract.methods.pendingRewardLock(account, i).call(), 18));

      if(reward > 0 ) 
      {
        lockedID.push(i);
      }
      pendingReward += reward;

      if (lockInfo.amount > 0) {
        lockedEntry.push({
          "key": i,
          "amount": Number(formatUnits(lockInfo.amount, 18)),
          "startTime": parseInt(lockInfo.startTime),
          "endTime": parseInt(lockInfo.endTime),
          "reward": reward,
        })
      }
    }
    setLockID(lockedID);
    setLockHistory(lockedEntry)
    setLockReward(pendingReward)
  }

  const approveTokens = async () => {
      const web3 = new Web3(providers);
      const pTGCContract = new web3.eth.Contract(pTGC.ABI, pTGC.Contract);
      try {
          await pTGCContract.methods.approve(pTGC.Contract, '115792089237316195423570985008687907853269984665640564039458').send({
            from: account
          }).on('transactionHash', function(payload) {
            txStart();
          }).on('error', function(error) {
              Swal.fire({
                title: "Error Found",
                text: error.message,
                icon: "error",
                showCancelButton: false,
                confirmButtonText: "Ok",
                showCloseButton: true,
                customClass: {
                  confirmButton: "btn btn-danger"
                }
              });
          }).then(function(receipt) {
              txDone()
              setTimeout(() => {
                txAfterDone()
              }, 2000)
              setRefresh(!refresh)
          });
      } catch (error) {
          Swal.fire({
            title: "Please try again",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "Ok",
            showCloseButton: true,
            customClass: {
              confirmButton: "btn btn-danger"
            }
          });
      }
  }

  const claimReward = async () => {
      const web3 = new Web3(providers);
      const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
      try {
          await stakingContract.methods.withdrawReward().send({
              from: account
          }).on('transactionHash', function(payload) {
              txStart();
          }).on('error', function(error) {
              Swal.fire({
                title: "Error Found",
                text: error.message,
                icon: "error",
                showCancelButton: false,
                confirmButtonText: "Ok",
                showCloseButton: true,
                customClass: {
                  confirmButton: "btn btn-danger"
                }
              });
          }).then(function(receipt) {
            txDone()
            setTimeout(() => {
              txAfterDone()
            }, 2000)
            setRefresh(!refresh)
          });
      } catch (error) {
        Swal.fire({
          title: "Please try again",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Ok",
          showCloseButton: true,
          customClass: {
            confirmButton: "btn btn-danger"
          }
        });
      }
  }

  const claimLockReward = async () => {
      const web3 = new Web3(providers);
      const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);
      try {
          await stakingContract.methods.withdrawRewardLock(lockID).send({
              from: account
          }).on('transactionHash', function(payload) {
              txStart();
          }).on('error', function(error) {
              Swal.fire({
                title: "Error Found",
                text: error.message,
                icon: "error",
                showCancelButton: false,
                confirmButtonText: "Ok",
                showCloseButton: true,
                customClass: {
                  confirmButton: "btn btn-danger"
                }
              });
          }).then(function(receipt) {
            txDone()
            setTimeout(() => {
              txAfterDone()
            }, 2000)
            setRefresh(!refresh)
          });
      } catch (error) {
        Swal.fire({
          title: "Please try again",
          text: error.message,
          icon: "error",
          showCancelButton: false,
          confirmButtonText: "Ok",
          showCloseButton: true,
          customClass: {
            confirmButton: "btn btn-danger"
          }
        });
      }
  }

  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true, 
    });
    handleModalOpen();
  }, []);

  const updatePage = () => { setRefresh(!refresh)}
  const closeWithdrawModal = () => setWithdrawModal(false);
  const closeLockModal = () => setLockModal(false);
  const closeStakeModal = () => setStakeModal(false);
  const openWithdrawModal = () => setWithdrawModal(true);
  const openLockModal = () => setLockModal(true);
  const openStakeModal = () => setStakeModal(true);

  const [burnBalance, setBurnBalance] = useState(0);
  const [stakingBalance, setStakingBalance] = useState(0);
  const [selfBalance, setSelfBalance] = useState(0);
  const [lpBalance, setLPBalance] = useState(0);
  const [staked, setStaked] = useState(0);
  const [locked, setLocked] = useState(0);

  const [currency, setCurrency] = useState("USD");
  const [holding, setHolding] = useState('');
  const [staking, setStaking] = useState('');
  const [volume, setVolume] = useState('');
  const [timespan, setTimeSpan] = useState(1);
  const [showResult, setShowResult] = useState(false);
  const [reward, setReward] = useState(0);
  const reflectionBalance = 333333333333 - (burnBalance + stakingBalance + selfBalance + lpBalance);

  useEffect(() => {
    setShowResult(false);
  }, [holding, staking, volume]);

  const calculateReward = async () => {
    const stakingFee = volume * 0.01;
    const reflectionFee = volume * 0.01;
    
    let reward = 0;

    if(staking > 0)
    {
      const rewardPerStaking = stakingFee / staked;
            reward += (rewardPerStaking * staking);
    }

    if(holding > 0) 
    {
      const rewardPerHolding = reflectionFee / reflectionBalance;
            reward += (rewardPerHolding * holding);
    }
    setReward(reward);
    setShowResult(true);
  };

  const handleModalOpen = async () => {
    const web3 = new Web3(providerURL());
    const pTGCContract = new web3.eth.Contract(pTGC.ABI, pTGC.Contract);
    const stakingContract = new web3.eth.Contract(Staking.ABI, Staking.Contract);

    setBurnBalance(parseInt(await pTGCContract.methods.balanceOf('0x0000000000000000000000000000000000000369').call()) / 10**18);
    setStakingBalance(parseInt(await pTGCContract.methods.balanceOf('0xc71f597a2ac39e47f07102e849d18489c96f39ef').call()) / 10**18);
    setSelfBalance(parseInt(await pTGCContract.methods.balanceOf('0x94534eeee131840b1c0f61847c572228bdfdde93').call()) / 10**18);
    setLPBalance(parseInt(await pTGCContract.methods.balanceOf('0xf5a89a6487d62df5308cdda89c566c5b5ef94c11').call()) / 10**18);
    setStaked(parseInt(await stakingContract.methods.totalStaked().call()) / 10**18);
    setLocked(parseInt(await stakingContract.methods.totalLocked().call()) / 10**18);
  };

  const handleCurrencyChange = (type) => {
    setCurrency(type);
    setVolume(""); 
  };
  return (
  <>
  <section className="PTGCSEC slideSec slideSecInner leftrightSecSpace">
    <div className="1 relative">
      <div className="row justify-content-between align-items-center">
        <div className="col-xl-7">
          <div className="sliderContent">
            <h1 className='good_times goldFont'  data-aos="fade-up"  data-aos-delay="300" data-aos-duration="600"><img src="./images/logoName.svg"  className="img-fluid logoNameInnerPage m-0"  /><span>Staking</span></h1>
            <p className="mt-0" data-aos="fade"  data-aos-delay="500" data-aos-duration="800">Stake your PTGC tokens to earn over 100% additional rewards while maintaining full self-custody. Rewards come from value generation, with PTGC being a zero-inflation, deflationary token.</p>
            <div className="bottomSliderBtn">
              <div className="d-flex gap-3 align-items-center"  data-aos="fade-right"  data-aos-delay="700" data-aos-duration="1000">
                {
                  account ? 
                  <>
                    <button onClick={openStakeModal}  className="borderbtn mybtn">
                    <span>Stake PTGC</span>
                      <img src="./images/circle_arrow.svg" className="img-fluid" />
                    </button>
                  </>
                  :
                  <>
                  <button className="borderbtn mybtn" onClick={onConnect}>
                    <span>Connect Wallet</span> <img src="./images/circle_arrow.svg" className="img-fluid"/>
                  </button>
                  </>
                }
                <a href="https://scan.pulsechain.com/address/0xC71f597a2AC39E47F07102E849d18489C96f39EF" target="_blank" className="mybtn underline text-white"><span>View Staking Contract</span></a>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-5 slR">
          <div className="bottomSliderRight " data-aos="fade-left"  data-aos-delay="700" data-aos-duration="1000">
            <div className="bSRIN overHide">
              <div className="snPortal">
                <div className="SRTOP d-flex flex-wrap justify-content-between align-items-center">
                  <span className="fInter goldFont">Reward Calculator</span>
                  <div className="iconSR"><img src="./images/MathOperations.svg" className="img-fluid" /></div>
                </div>
              </div>
              <div className='row'>
                <div className="col-md-6">
                  <div className="amountSTaking pb-0">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">Holding Amount</label>
                    <div className="inputBGCOin d-flex justify-content-between align-items-center gap-3">
                      <div className="d-flex gap-2 w-100">
                        <img src="./images/ptgccircle.svg" className="img-fluid" />
                        <input
                          type="text"
                          className="nobginput p-0 w-100"
                          placeholder="0.00"
                          style={{ borderRadius: '0px', background: 'transparent', border: '0px', padding: '0px' }}
                          value={
                            holding === ""
                              ? ""
                              : Number(holding.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 8
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "") {
                              setHolding("");
                              return;
                            }
                            if (isNaN(raw)) return;
                            const num = Math.min(Number(raw), Number(reflectionBalance));
                            setHolding(num.toString());
                          }}
                        />
                      </div>
                      <div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="amountSTaking pb-0">
                  <label className="fInter mb-1" htmlFor="burnTodayRange">Staking Amount</label>
                  <div className="inputBGCOin d-flex justify-content-between align-items-center gap-3">
                    <div className="d-flex gap-2 w-100">
                      <img src="./images/ptgccircle.svg" className="img-fluid" />
                       <input
                          type="text"
                          className="nobginput p-0 w-100"
                          placeholder="0.00"
                          style={{
                            borderRadius: '0px',
                            background: 'transparent',
                            border: '0px',
                            padding: '0px'
                          }}
                          value={
                            staking === ""
                              ? ""
                              : Number(staking.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 8
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "") {
                              setStaking("");
                              return;
                            }
                            if (isNaN(raw)) return;
                            const num = Math.min(Number(raw), Number(staked));
                            setStaking(num.toString());
                          }}
                        />
                    </div>
                    <div>
                    </div>
                  </div>
                 </div>
                </div>
                <div className="col-md-12">
                  <div className="amountSTaking pb-0">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">
                      Enter Daily Volume ({currency})
                    </label>

                    <div className="inputBGCOin d-flex justify-content-between align-items-center gap-3">
                      <div className="d-flex gap-2 w-100">
                        

                        {currency === "PTGC" ? (
                          <img
                            src="./images/ptgccircle.svg"
                            className="img-fluid"
                            alt="icon"
                          />
                        ) : (
                          <img
                            src="./coinimages/0x15d38573d2feeb82e7ad5187ab8c1d52810b1f07.png"
                            className="img-fluid"
                            alt="icon"
                            style={{filter: 'grayscale(1)'}}
                          />
                        )}

                        
                        <input
                          type="text"
                          className="nobginput w-100"
                          placeholder={currency === "PTGC" ? "0.00 PTGC" : "0.00 USD"}
                          value={
                            volume === "" || isNaN(Number(volume.toString().replace(/,/g, "")))
                              ? ""
                              : Number(volume.toString().replace(/,/g, "")).toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 8,
                                })
                          }
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, "");
                            if (raw === "" || !isNaN(raw)) {
                              setVolume(raw);
                            }
                          }}
                        />
                      </div>
                      <div className="d-flex gap-1">
                        <button
                          className={`spanSpecial ${currency === "PTGC" ? "active" : ""}`}
                          onClick={() => handleCurrencyChange("PTGC")}
                        >
                          PTGC
                        </button>

                        <button
                          className={`spanSpecial ${currency === "USD" ? "active" : ""}`}
                          onClick={() => handleCurrencyChange("USD")}
                        >
                          USD
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                   <div className="amountSTaking ">
                    <label className="fInter mb-1" htmlFor="burnTodayRange">Select Time Span</label>
                     <div className="relativeSelect w-100">
                      <select className="form-control" onChange={(e) => setTimeSpan(e.target.value)}>
                        <option value="1">Daily</option>
                        <option value="7">Weekly</option>
                        <option value="30">Monthly</option>
                        <option value="365">1 Year</option>
                        <option value="1825">5 Years</option>
                        <option value="3650">10 Years</option>
                      </select>
                      <i className="fa-solid fa-angle-down"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-2">
                {
                   (holding > 0 || staking > 0) && volume > 0 ?
                   <>
                    <button  className=" borderbtn mybtn w-100 d-flex justify-content-between align-items-center m-0" onClick={() => calculateReward()}>
                      <span>Calculate</span><span className="iconiconSR"><img className="img-fluid m-0" src="./images/Scales.svg"/></span>
                    </button>
                   </>
                   :
                   <>
                    <button className=" borderbtn mybtn w-100 d-flex justify-content-between align-items-center m-0" disabled>
                      <span>Calculate</span><span className="iconiconSR"><img className="img-fluid m-0" src="./images/Scales.svg"/></span>
                    </button>
                   </>
                }
              </div>
              {
                showResult ?
                <>
                <div className="borderBottom borderBottom0">
                  <div className=" bggrey">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="snPortal borderBottom">
                          <div className="">
                            <span className="fInter">Total Results</span>
                            <div className="dollorVal mt-0">
                              {
                                currency === "USD" ?
                                <>
                                 <span className="val">{parseFloat((reward / ptgcPrice) * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </>
                                :
                                <>
                                 <span className="val">{parseFloat(reward * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </>
                              }
                              <span className="dollor2">PTGC</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="snPortal">
                          <div className="">
                            <span className="fInter">Total  Results</span>
                            <div className="dollorVal mt-0">
                              <span className="dollor">$</span>
                              {
                                currency === "USD" ?
                                <>
                                 <span className="val">{parseFloat(reward * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </>
                                :
                                <>
                                 <span className="val">{parseFloat(reward * ptgcPrice * timespan).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                </>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </>
                :
                <>
                </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section className="clippathSec PTGCSEC  stakeSec StatsSec leftrightSecSpace padsec">
    <div className="d-flex justify-content-between align-items-center">
      <h2 className="good_times goldFont">Your Stakes</h2>
    </div>
    <div className="statsALL">
      <div className="row">
        <div className="col-sm-12">
          <div className="subcontent subPad SRTOP p-0">
            <div className="row">
              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade" data-aos-delay="800" data-aos-duration="400">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span>Total PTGC Earned</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(PTGCEarned).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade" data-aos-delay="800" data-aos-duration="400">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span>PTGC Earned From Holding</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(earnedFromHolding).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade" data-aos-delay="800" data-aos-duration="400">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span>PTGC Earned From Staking</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(earnedFromStaking).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade" data-aos-delay="800" data-aos-duration="400">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span>PTGC Earned From Locking</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(earnedFromLocking).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              
             
              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade"  data-aos-delay="800" data-aos-duration="1200">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span className="">Total PTGC Held</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(pTGCBalance).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade"  data-aos-delay="800" data-aos-duration="1200">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span className="">Total Liquid PTGC</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(pTGCBalance - stakedpTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade"  data-aos-delay="800" data-aos-duration="1400">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span className="">Total PTGC Staked</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(stakedpTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade"  data-aos-delay="800" data-aos-duration="1200">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span className="">Total PTGC Locked</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(lockedpTGC).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade" data-aos-delay="800" data-aos-duration="400">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span>Claimable PTGC Earned From Locking</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(lockReward).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes"  data-aos="fade"  data-aos-delay="800" data-aos-duration="600">
                  <div className="relative">
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span>Claimable PTGC Earned From Staking</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="dollorVal dollorValRight mt-0"><span className="val f16">{parseFloat(stakeReward).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span><span className="dollor">PTGC</span></div>           
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-lg-6 mobBorderBottomAdd991 borderBottom" data-aos="fade"  data-aos-delay="800" data-aos-duration="1000">
                <div className="snstakes">
                  <div className="relative">
                    <h2>Earn More Reward</h2>
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span className="">Earn more rewards by locking your tokens</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="someBtns SRTOP  d-flex gap-2">
                            {
                              account ?
                              <>
                              <button onClick={openStakeModal} className="someSnbtn d-flex align-items-center w-100 justify-content-between">
                                <span>Stake More PTGC</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circle_arrow.svg"/></div>
                              </button>
                              </>
                              :
                              <>
                              <button className="someSnbtn d-flex align-items-center w-100 justify-content-between disabled" disabled>
                                <span>Stake More PTGC</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circle_arrow.svg"/></div>
                              </button>
                              </>
                            }
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="someBtns SRTOP  d-flex gap-2">
                            {
                              stakedpTGC > 0 ?
                              <>
                              <button onClick={openLockModal} className="someSnbtn d-flex align-items-center w-100 justify-content-between">
                                <span>Lock More PTGC</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circleLock.svg" /></div>
                              </button>
                              </>
                              :
                              <>
                              <button className="someSnbtn d-flex align-items-center w-100 justify-content-between disabled" disabled>
                                <span>Lock More PTGC</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circleLock.svg" /></div>
                              </button>
                              </>
                            }
                          </div>
                        </div>
                      </div>
                    </div>         
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-lg-12 mobBorderBottomAdd991 borderBottom">
                <div className="snstakes" data-aos="fade"  data-aos-delay="800" data-aos-duration="2000">
                  <div className="relative">
                    <h2>Unstake / Claim</h2>
                    <div className="d-flex justify-content-between gap-1 align-items-center">
                      <div className="perVal fInter d-flex align-items-center">
                        <span className="">Unstaking will incur a 1% fee, which is redistributed to all other stakers.</span>
                      </div>
                    </div>
                    <div className="statBottom">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="someBtns SRTOP  d-flex gap-2">
                            {
                              stakedpTGC > 0 ?
                              <>
                              <button onClick={openWithdrawModal} className="someSnbtn d-flex align-items-center w-100 justify-content-between">
                                <span>Unstake PTGC</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circlewithdraw.svg" /> </div>
                              </button>
                              </>
                              :
                              <>
                              <button className="someSnbtn d-flex align-items-center w-100 justify-content-between disabled" disabled>
                                <span>Unstake PTGC</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circlewithdraw.svg" /></div>
                              </button>
                              </>
                            }
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="someBtns SRTOP  d-flex gap-2">
                            {
                              stakeReward > 0.01 ?
                              <>
                              <button onClick={claimReward} className="someSnbtn d-flex align-items-center w-100 justify-content-between">
                                <span>Claim Stake Reward</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circleMinus.svg" /> </div>
                              </button>
                              </>
                              :
                              <>
                              <button className="someSnbtn d-flex align-items-center w-100 justify-content-between disabled" disabled>
                                <span>Claim Stake Reward</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circleMinus.svg" /></div>
                              </button>
                              </>
                            }
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="someBtns SRTOP  d-flex gap-2">
                            {
                              lockID.length > 0 ?
                              <>
                              <button onClick={claimLockReward} className="someSnbtn d-flex align-items-center w-100 justify-content-between">
                                <span>Claim Lock Reward</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circleMinus.svg" /> </div>
                              </button>
                              </>
                              :
                              <>
                              <button className="someSnbtn d-flex align-items-center w-100 justify-content-between disabled" disabled>
                                <span>Claim Lock Reward</span> 
                                <div className="iconSR"><img className="img-fluid" src="./images/circleMinus.svg" /></div>
                              </button>
                              </>
                            }
                          </div>
                        </div>
                      </div>
                    </div>         
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <LockTable lockHistory={lockHistory} account={account} providers={providers} updatePage={updatePage}/>
  <EcosystemStats staked={staked} locked={locked}/>
  <StakePopup modalIsOpen={stakeModal} closeModal={closeStakeModal} account={account} providers={providers} unstakedpTGC={unstakedpTGC} minStaking={minStaking} pTGCAllowance={pTGCAllowance} updatePage={updatePage}/>
  <LockPopup modalIsOpen={lockModal} closeModal={closeLockModal} account={account} providers={providers} unlockedpTGC={unlockedpTGC} updatePage={updatePage}/>
  <UnstakePopup modalIsOpen={withdrawModal} closeModal={closeWithdrawModal} account={account} providers={providers} stakedpTGC={(stakedpTGC - lockedpTGC)} updatePage={updatePage}/>
  </>
  );
};

export default IndexWrapper;